export default {"src":"/_next/static/media/icon_metamask.635b7a4f.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};